import React from "react";

import ExecImg from "../../assets/Images/Exec.png";
import ManagerImg from "../../assets/Images/manager.png";
import EmployeeImg from "../../assets/Images/employee.png";

import { LearnMoreBtn } from "../LearnMoreBtn/LearnMoreBtn";

export function ExecManagerEmployee(props) {
  return (
    <>
      <div className="execManagerEmployeeHeader">
        <h3 className="mediumHeadline textCentre">
          Built for Teams of Any Size
        </h3>

        <p className="bodyText textCentre">
          Whether you're running a single facility or managing thousands of
          employees across multiple sites, our platform scales with you.
          Customize workflows that give you full visibility and keep everyone
          aligned — from the field to the office.
        </p>
      </div>

      <section className="execManagerEmployeeContainer">
        <div className="cardItem">
          <div className="cardItemTextContainer">
            <h3 className="emphasisHeadline mb-1">Executives</h3>
            <p className="bodyText">
              Gain instant visibility into your organization's safety
              performance. Track compliance trends, monitor analytics, and
              ensure every facility is meeting standards — all from one central
              dashboard.
            </p>

            <LearnMoreBtn />
          </div>
          <img
            src={ExecImg}
            alt=""
            className="peopleSectionImg"
            draggable={false}
          />
        </div>

        <div className="cardItem">
          <div className="cardItemTextContainer">
            <h3 className="emphasisHeadline mb-1">Managers</h3>
            <p className="bodyText">
              Stay on top of safety events as they happen. Easily review
              incident and hazard reports, assign follow-ups, and keep your team
              informed and accountable.
            </p>
            <LearnMoreBtn />
          </div>
          <img
            src={ManagerImg}
            alt=""
            className="peopleSectionImg"
            draggable={false}
          />
        </div>

        <div className="cardItem">
          <div className="cardItemTextContainer">
            <h3 className="emphasisHeadline mb-1">Employees</h3>
            <p className="bodyText">
              Check equipment before you use it — fast and easy. Scan a QR code,
              complete the pre-use inspection on your phone, and know the gear
              is safe before getting to work.
            </p>
            <LearnMoreBtn />
          </div>
          <img
            src={EmployeeImg}
            alt=""
            className="peopleSectionImg"
            draggable={false}
          />
        </div>
      </section>
    </>
  );
}
